import { estimateTextWidth, niceTicks } from './scale.js';
/**
 * Ticks and domain for a value axis. `includeZero` keeps the baseline in view
 * (always on for bars, whose length must start at zero).
 */
export function valueAxisLayout(extent, { includeZero, domain = ['auto', 'auto'], tickCount, format, }) {
    let [lo, hi] = extent ?? [0, 1];
    if (includeZero) {
        lo = Math.min(lo, 0);
        hi = Math.max(hi, 0);
    }
    if (domain[0] !== 'auto')
        lo = domain[0];
    if (domain[1] !== 'auto')
        hi = domain[1];
    let ticks = niceTicks(lo, hi, tickCount);
    if (domain[0] !== 'auto' || domain[1] !== 'auto') {
        const fixedLo = domain[0] === 'auto' ? (ticks[0] ?? lo) : domain[0];
        const fixedHi = domain[1] === 'auto' ? (ticks[ticks.length - 1] ?? hi) : domain[1];
        ticks = ticks.filter((t) => t >= fixedLo && t <= fixedHi);
        return {
            ticks,
            domain: [fixedLo, fixedHi],
            labelWidth: Math.max(0, ...ticks.map((t) => estimateTextWidth(format(t)))),
        };
    }
    return {
        ticks,
        domain: [ticks[0] ?? lo, ticks[ticks.length - 1] ?? hi],
        labelWidth: Math.max(0, ...ticks.map((t) => estimateTextWidth(format(t)))),
    };
}
/** About one value tick per 48px of plot height, at least two. */
export function tickCountFor(length) {
    return Math.max(2, Math.min(8, Math.floor(length / 48)));
}
/** Index of the position closest to `px` in a sorted list of positions. */
export function nearestIndex(positions, px) {
    if (positions.length === 0)
        return null;
    let lo = 0;
    let hi = positions.length - 1;
    while (hi - lo > 1) {
        const mid = (lo + hi) >> 1;
        if ((positions[mid] ?? 0) < px)
            lo = mid;
        else
            hi = mid;
    }
    return Math.abs((positions[lo] ?? 0) - px) <= Math.abs((positions[hi] ?? 0) - px) ? lo : hi;
}
export const DEFAULT_INTERACTION_LABELS = {
    chart: 'chart',
    keyboardHint: 'Use the arrow keys to inspect values.',
    noValue: 'No data',
    total: 'Total',
};
/** Shortens a label to about `maxWidth` px, ending in an ellipsis. */
export function truncateLabel(label, maxWidth, fontSize = 11) {
    const fit = Math.floor(maxWidth / (fontSize * 0.6));
    if (label.length <= fit)
        return label;
    return fit <= 1 ? '…' : `${label.slice(0, fit - 1).trimEnd()}…`;
}
//# sourceMappingURL=layout.js.map